import * as React from 'react';
import './questionCard.module.scss';
import { CardFormat } from "../../atoms/surveys/cardFormat";
import { OneByOneFormat } from "../../atoms/surveys/oneByOneFormat";
import { SurveyQuestionFormat } from "../../../../commonv3/types/surveys";
import { useEffect } from 'react';

type Props = {
    questionNumber: number;
    totalQuestions: number;
    sentence: string;
    subSentence?: any;
    required: boolean;
    errorMessage?: string;
    children?: any;
    onBlur?: () => any;
    className?: string;
    bodyClassName?: string;
    styleName?: string;
    format?: SurveyQuestionFormat;
};

function useOuterClickHandler(ref, handler) {
    useEffect(
        () => {
            const listener = (event) => {
                // Do nothing if clicking ref's element or descendent elements
                if (!ref.current || ref.current.contains(event.target)) {
                    return;
                }

                handler(event);
            };

            document.addEventListener('mousedown', listener);
            document.addEventListener('touchstart', listener);

            return () => {
                document.removeEventListener('mousedown', listener);
                document.removeEventListener('touchstart', listener);
            };
        },
        [ref, handler]
    );
}

export const QuestionCard = ({
    questionNumber,
    totalQuestions,
    sentence,
    subSentence,
    required,
    errorMessage,
    className,
    bodyClassName,
    children,
    onBlur,
    format,
}: Props) => {
    switch (format) {
        case 'card':
            return (
                <CardFormat
                    questionNumber={questionNumber}
                    totalQuestions={totalQuestions}
                    sentence={sentence}
                    subSentence={subSentence}
                    required={required}
                    errorMessage={errorMessage}
                    className={className}
                    bodyClassName={bodyClassName}
                    onBlur={onBlur}
                    useOuterClickHandler={useOuterClickHandler}
                >
                    {children}
                </CardFormat>
            )
        case 'one_by_one':
            return (
                <OneByOneFormat
                    questionNumber={questionNumber}
                    totalQuestions={totalQuestions}
                    sentence={sentence}
                    subSentence={subSentence}
                    required={required}
                    errorMessage={errorMessage}
                    className={className}
                    bodyClassName={bodyClassName}
                    onBlur={onBlur}
                    useOuterClickHandler={useOuterClickHandler}
                >
                    {children}
                </OneByOneFormat>
            )
        default :
            return (
                <CardFormat
                    questionNumber={questionNumber}
                    totalQuestions={totalQuestions}
                    sentence={sentence}
                    subSentence={subSentence}
                    required={required}
                    errorMessage={errorMessage}
                    className={className}
                    bodyClassName={bodyClassName}
                    onBlur={onBlur}
                    useOuterClickHandler={useOuterClickHandler}
                >
                    {children}
                </CardFormat>
            )
    }
};
